import { render, staticRenderFns } from "./payslipitem.vue?vue&type=template&id=f70c5036&scoped=true"
import script from "./payslipitem.vue?vue&type=script&lang=js"
export * from "./payslipitem.vue?vue&type=script&lang=js"
import style0 from "./payslipitem.vue?vue&type=style&index=0&id=f70c5036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70c5036",
  null
  
)

export default component.exports